import { Endpoints } from '@/core/models/endpoints.interface';

export const SYSTEM_NOTIFICATION_ENDPOINTS: Pick<Endpoints, 'GET_ALL'> = {
   GET_ALL: () => `system-notification`,
};
